﻿import Rest from '@/rest';

class Settings {
    GetShowDeleted() {
        return Rest.Get('/api/settings/getshowdeleted');
    }
    SetShowDeleted(show) {
        return Rest.Get(`/api/settings/setshowdeleted/${show}`);
    }
    Get() {
        return Rest.Get('/api/settings/get');
    }

    GetUser() {
        return Rest.Get('/api/settings/getuser');
    }

    Save(settings) {
        return Rest.Post('/api/settings/save/', settings);
    }

    SaveUser(settings) {
        return Rest.Post('/api/settings/saveuser/', settings);
    }

    Backup() {
        return Rest.Get('/api/settings/backup');
    }

    Restore() {
        return Rest.Get('/api/settings/restore');
    }
}

export default new Settings();